import styles from "@/components/FAQ/FAQ.module.scss";
import AccordionSingle from "../accordionSingle/accordionSingle";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { svgImages } from "@/lib/svgImages";
import { getFAQData } from "@/lib/wordpressApi";
import RoundedButton from "../roundedButton/roundedButton";

interface FAQItem {
  title: string;
  description: string;
}

interface FAQData {
  acf?: {
    faq: FAQItem[];
  };
}

interface AccordionSingleProps {
  id: number;
  title: string;
  subTitle: string;
  description: string;
  selectedId: string;
  setSelectedId: (id: string) => void;
}

const FAQ: React.FC = () => {
  const [selectedId, setSelectedId] = useState<string>("0");
  const { t } = useTranslation();
  const [data, setData] = useState<FAQItem[] | null>(null);

  useEffect(() => {
    (async () => {
      const data: FAQData | null = await getFAQData();
      setData(data?.acf?.faq || null);
    })();
  }, []);

  return (
    <div className={`${styles["faq"]}`}>
      <div className={`${styles["headerContainer"]}`}>
        <div
          className={`${styles["faqIcon"]}`}
          dangerouslySetInnerHTML={{ __html: svgImages.faqIcon }}
        ></div>
        <h3 className={`font-size-48 line-height-title`}>FAQ</h3>
      </div>
      <div className={`${styles["contnetContainer"]}`}>
        <div className={`${styles["faqAccordion"]}`}>
          {data &&
            data.map((item: FAQItem, index: number) => (
              <AccordionSingle
                key={index}
                id={index}
                title={item.title}
                subTitle={``}
                description={item.description}
                selectedId={selectedId}
                setSelectedId={setSelectedId}
              />
            ))}
        </div>
      </div>
      <div className="flex flex-col gap-4 pt-10">
        <span className={styles.helpTitle}>Need More Help?</span>{" "}
        <p className={`styles.helpDescription`}>
          Whether you're looking to get started with QRHub, need technical
          support, or have partnership inquiries, we're ready to help.
        </p>
        <RoundedButton
          title="Get in Touch"
          url="https://qhb.io/help"
          light={false}
          fill={true}
          target="_blank"
        />
      </div>
    </div>
  );
};

export default FAQ;
